export const messages = {
    'login': 'Para continuar acessando,',
    'register': 'Para continuar o cadastro da metodologia,',
    'feedback': 'Para continuar o feedback,',
    'default': ''
}

export default {messages};